import {
  Box,
  CircularProgress,
  DialogActions as MuiDialogActions,
  Paper,
  Table,
  TableBody,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import {
  CustomButton,
  DialogBody,
  DialogContainer,
  DialogTitle,
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
} from '../../../../common/components';
import { formatDateTime } from '../../utils/puntajeFormatters';

const formatCurrency = (value) =>
  new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    maximumFractionDigits: 2,
  }).format(Number(value || 0));

const formatPeriod = (year, month) => {
  if (!year || !month) {
    return '-';
  }

  return `${String(month).padStart(2, '0')}/${year}`;
};

const ContractDebtDetailDialog = ({ open, onClose, debtDetail, isLoading, error, contractRow }) => {
  const subscriberNames = debtDetail?.subscriber_names || contractRow?.subscriber_names || [];

  return (
    <DialogContainer open={open} onClose={onClose} size="large" minHeight="30vh">
      <DialogTitle>Detalle de Mora del Contrato</DialogTitle>

      <DialogBody>
        <Box sx={{ mb: 2 }}>
          <Typography variant="h6">
            Contrato {debtDetail?.contract_number || contractRow?.contract_number || '-'}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Suscriptor(es): {subscriberNames.join(', ') || '-'}
          </Typography>
        </Box>

        {isLoading ? (
          <Box
            sx={{
              minHeight: 220,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <CircularProgress size={32} />
          </Box>
        ) : error ? (
          <Paper elevation={0} sx={{ p: 3, border: '1px solid', borderColor: 'divider' }}>
            <Typography variant="body1">No se pudo obtener el detalle de mora del contrato.</Typography>
          </Paper>
        ) : !debtDetail?.coupons?.length ? (
          <Paper elevation={0} sx={{ p: 3, border: '1px solid', borderColor: 'divider' }}>
            <Typography variant="body1">El contrato no tiene cupones en mora para mostrar.</Typography>
          </Paper>
        ) : (
          <>
            <Box sx={{ mb: 2, display: 'flex', gap: 3, flexWrap: 'wrap' }}>
              <Typography variant="body2">
                Cupones en mora: <strong>{debtDetail.overdue_coupon_count}</strong>
              </Typography>
              <Typography variant="body2">
                Total en mora: <strong>{formatCurrency(debtDetail.total_debt_amount)}</strong>
              </Typography>
            </Box>

            <GeneralTableBox>
              <Table>
                <TableHead>
                  <TableRow>
                    <HeadTableCell>Concepto</HeadTableCell>
                    <HeadTableCell>Cuota</HeadTableCell>
                    <HeadTableCell>Periodo</HeadTableCell>
                    <HeadTableCell>Vencimiento mora</HeadTableCell>
                    <HeadTableCell sx={{ textAlign: 'right' }}>Importe mora</HeadTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {debtDetail.coupons.map((coupon) => (
                    <TableRow key={coupon.uuid} hover>
                      <RowTableCell>{coupon.fee_name || '-'}</RowTableCell>
                      <RowTableCell>{coupon.fee_number || '-'}</RowTableCell>
                      <RowTableCell>{formatPeriod(coupon.year, coupon.month)}</RowTableCell>
                      <RowTableCell>{formatDateTime(coupon.effective_due_date)}</RowTableCell>
                      <RowTableCell sx={{ textAlign: 'right', fontWeight: 600 }}>
                        {formatCurrency(coupon.effective_amount)}
                      </RowTableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </GeneralTableBox>
          </>
        )}
      </DialogBody>

      <MuiDialogActions sx={{ px: 3, pb: 3 }}>
        <CustomButton variant="outlined" onClick={onClose}>
          Cerrar
        </CustomButton>
      </MuiDialogActions>
    </DialogContainer>
  );
};

export default ContractDebtDetailDialog;
